/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer'
import GetchkdUserEdit from './GetchkdUserEdit';
import Loader from '../../../../../../components/ui-elements/loader';
import { FaHistory } from 'react-icons/fa';
import GetchkdHistory from './GetchkdHistory';
import { useCallback } from 'react';
import { getAllGetchkdUsers } from '../../../../../../store/reducers/getchkdUser/getchkdUserAction';

const GetchkUsersList = () => {
    const [selectedGetchkdUser, setSelectedGetchkdUser] = useState({});
    const [openEditGetchkdUser, setOpenEditGetchkdUser] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openHistory, setOpenHistory] = useState(false);
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers)
    const dispatch = useDispatch()

    const fetchGetchkdUSers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllGetchkdUsers()).unwrap()
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch])
    useEffect(() => {
        fetchGetchkdUSers()
    }, [fetchGetchkdUSers]);
    const handleCloseDialog = () => {
        setOpenEditGetchkdUser(false);
        setOpenHistory(false);
    };
    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="GetchkUsersList">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="GetChkd ID" />
                            <StyledTableCell label="Email" />
                            <StyledTableCell label="User Name" />

                            <StyledTableCell label="Details" />

                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((row) => (
                            <StyledTableRow key={row.getChkdID}>
                                <StyledTableCell label={row.getChkdID} />
                                <StyledTableCell label={row.email} />
                                <StyledTableCell label={row.username} />

                                <StyledTableCell>
                                    {row.accountDetails?.length > 0 ?
                                        <Typography style={{ fontWeight: 'bold' }} color={row.accountDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                            {row.accountDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'} </Typography> : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell align="right"  >
                                    <Tooltip title="User Edit" placement="left" arrow>

                                        <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedGetchkdUser(row); setOpenEditGetchkdUser(true) }}>
                                            <BsFillPencilFill />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="User History" placement="left" arrow>

                                        <IconButton color='primary' onClick={() => { setSelectedGetchkdUser(row); setOpenHistory(true) }}>
                                            <FaHistory />
                                        </IconButton>
                                    </Tooltip>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}

            <DialogContainer
                open={openEditGetchkdUser}
                handleClose={handleCloseDialog}
            >
                <GetchkdUserEdit
                    selectedGetchkdUser={selectedGetchkdUser}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistory}
                handleClose={handleCloseDialog}
            >
                <GetchkdHistory
                    selectedGetchkdUser={selectedGetchkdUser}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}

export default GetchkUsersList;